import $ from 'jquery';
import SVGInjector from 'svg-injector';
import { triggerStateChangedRequest } from '~core';
import { getFormatNameAndOrientration } from '~loader/loader-utils';
import { editorConfig } from '~config';
import { getState } from '~src/state';
import { doesSelectedProjectRequireFuneral } from '~loader/loader-utils';
import { handleShadowColorChange } from '~src/sidebar/index';
import { handleTextBorderColorChange } from '~src/sidebar/handleTextBorderColorChange';
import { deleteAnimationsByObjRefId } from '~video';
import { toggleMagicFrameEditMode } from '~core/magicFrame';
import { clearSelectionsStyles } from '~src/utils';

function setSvgColor(id, color) {
  const paths = $(id).find('path');

  for (let i = 0; i < paths.length; i++) {
    paths[i].setAttribute('style', `fill:${color}`);
  }

  const rects = $(id).find('rect');

  for (let i = 0; i < rects.length; i++) {
    rects[i].setAttribute('style', `fill:${color}`);
  }
}

function getFontSizeValue() {
  let fontSize;

  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    // the text object is being edited
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.fontSize
    ) {
      // everything was selected
      fontSize = activeObject.get('fontSize');
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      fontSize = activeObject.get('fontSize');
    } else {
      // a portion of text was selected
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        fontSize = selectionStyles[0]['fontSize'];
      }

      // the child does not have a custom font size
      if (!fontSize) {
        fontSize = activeObject.get('fontSize');
      }
    }
  } else {
    // the text object is simply selected
    fontSize = activeObject.get('fontSize');
  }
  return fontSize;
}

async function changeFontColor() {
  const hexColor = $(this).data('hex-color');
  const activeObject = getState('activeObject');

  if (getState('setShadowColorActive', false)) {
    return handleShadowColorChange(hexColor);
  }

  if (getState('setTextBorderColorActive', false)) {
    return handleTextBorderColorChange(hexColor);
  }

  // Apply to all selected texts if ActiveSelection
  if (
    activeObject &&
    activeObject.type === 'activeSelection' &&
    typeof activeObject.getObjects === 'function'
  ) {
    const texts = activeObject
      .getObjects()
      .filter((o) => o.type === 'textbox' || o.type === 'i-text');
    if (texts.length) {
      texts.forEach((t) => {
        try {
          t.set('fill', hexColor);
          t.set('dirty', true);
        } catch (e) {
          console.error('Failed applying color to grouped text selection', e);
        }
      });
      window.canvas.renderAll();
      triggerStateChangedRequest();
      return;
    }
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fill');
      activeObject.set('fill', hexColor);
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      activeObject.set('fill', hexColor);
    } else {
      // a portion of text was selected
      activeObject.setSelectionStyles({
        fill: hexColor,
      });
    }
  } else {
    clearSelectionsStyles(activeObject, 'fill');
    activeObject.set('fill', hexColor);
  }
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

function addDefaultColors() {
  const html = editorConfig.defaultColors.reduce((acc, color) => {
    const colorHtml = `<div style="background-color:${color};" data-hex-color="${color}" class="color-box"></div>`;
    acc += colorHtml;

    return acc;
  }, '');

  $('#colors-default').html(html);

  $('[data-hex-color').click(changeFontColor);
}

function initColors() {
  addDefaultColors();
}

// legacy text header update helpers removed (floating controls manage UI)

export const isGroupSelection = () => {
  const getActiveObject = window.canvas.getActiveObject();
  const isGroup =
    typeof getActiveObject._objects !== 'undefined' &&
    getActiveObject._objects instanceof Array &&
    getActiveObject._objects.length > 0;

  return isGroup;
};

function deleteObject() {
  const objects = window.canvas.getActiveObjects();

  objects.forEach((obj) => {
    window.canvas.remove(obj);
    deleteAnimationsByObjRefId(obj);
  });
  window.canvas.discardActiveObject().renderAll();

  triggerStateChangedRequest();
}

function deselectObjects() {
  const activeObjects = window.canvas.getActiveObjects();

  for (const activeObject of activeObjects) {
    if (activeObject.type === 'MagicFrame') {
      if (activeObject.isEditing) {
        toggleMagicFrameEditMode();
      }
    } else if (typeof activeObject._magicFrame !== 'undefined') {
      if (activeObject._magicFrame.isEditing) {
        toggleMagicFrameEditMode();
      }
    }
  }
  window.canvas.discardActiveObject().renderAll();
}

function fixTooltipIssueOnClick() {
  $('[data-toggle="tooltip"]').on('click', function () {
    $(this).tooltip('hide');
  });
}

function injectSvgIcons() {
  const mySVGsToInject = document.querySelectorAll('img.inject-me');

  const injectorOptions = {
    evalScripts: 'once',
    pngFallback: 'assets/png',
    each: function (svg) {
      // Skip global tinting for floating controls icons (they manage color themselves)
      try {
        if (svg.closest && svg.closest('.floating-controls-container')) {
          // Preserve original SVG styling for floating controls
          try {
            svg.setAttribute('data-preserve-style', '');
          } catch (e) {
            console.error('Failed setting preserve-style attribute on SVG', e);
          }
          return; // do not tint
        }
      } catch (e) {
        console.error('Error skipping icon tint in floating controls', e);
      }

      // If the SVG sits inside Giotto buttons or navbars, let CSS currentColor drive the color
      try {
        if (
          svg.closest &&
          svg.closest(
            '.g-btn, .btn-nav-custom, #navbar-canvas, #navbar-private'
          )
        ) {
          return; // CSS handles color (fill/stroke: currentColor)
        }
      } catch (e) {
        console.error('Error skipping icon tint in buttons/navbars', e);
      }

      // Default: set to inactiveControlColor for non-DS contexts
      const id = svg.getAttribute('id');
      setSvgColor(`#${id}`, editorConfig.styles.inactiveControlColor);
    },
  };

  SVGInjector(mySVGsToInject, injectorOptions);
}

function displayHeaderControls() {
  $('#editor-header-controls').show();
}

function setHeaderSummary() {
  const requiresFuneral = doesSelectedProjectRequireFuneral();
  const format = getState('selected.formato');
  const projectType = getState('selected.tipo');
  const template = getState('selected.template');

  if (requiresFuneral) {
    const servizio = getState('selected.servizio', {});
    if (servizio) {
      const nomeDefunto = `${servizio.nome} ${servizio.cognome}`;
      $('#editor-header-defunto').text(nomeDefunto);
    }
  }

  const { name: formatName } = getFormatNameAndOrientration(format);

  $('#editor-header-tipo').text(projectType.name);
  $('#editor-header-formato').text(formatName);
  if (template && template.name) {
    $('#editor-header-modello').text(template.name);
  }
  $('#editor-header-section').show();
}

const changeToLock = () => {
  $('#img-lock').attr({ style: 'content:url(/assets/svg/img-un-lock.svg)' });
};

const changeToUnLock = () => {
  $('#img-lock').attr({ style: 'content:url(/assets/svg/img-lock.svg)' });
};

const unlockObject = (object) => {
  object.set({
    lockMovementX: false,
    lockMovementY: false,
    lockScalingX: false,
    lockScalingY: false,
    lockRotation: false,
    borderColor: '#ccc',
  });

  if (object.type === 'textbox') {
    object.set({
      editable: true,
    });
  }
};

const lockObject = (object) => {
  object.set({
    lockMovementX: true,
    lockMovementY: true,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    borderColor: 'red',
  });
  if (object.type === 'textbox') {
    object.set({
      editable: false,
    });
  }
};

const toggleObjectLock = () => {
  const selection = window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  let objects;

  if (isGroupSelection()) {
    objects = selection._objects;
  } else {
    objects = [selection];
  }

  const objectsLocked = [];
  objects.forEach((object) => {
    const isLocked = object.lockMovementY && object.lockMovementX;
    objectsLocked.push(!isLocked);

    if (isLocked) {
      unlockObject(object);
      changeToLock();
    } else {
      lockObject(object);
      changeToUnLock();
    }
  });

  if (isGroupSelection()) {
    const atLeastOneIsLocked = objectsLocked.includes(true);

    if (atLeastOneIsLocked) {
      const selection = window.canvas.getActiveObject();
      selection.set({
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true,
        borderColor: 'red',
      });
    } else {
      const selection = window.canvas.getActiveObject();
      selection.set({
        lockMovementX: false,
        lockMovementY: false,
        lockScalingX: false,
        lockScalingY: false,
        lockRotation: false,
        borderColor: '#ccc',
      });
    }
  }

  window.canvas.renderAll();
  triggerStateChangedRequest();
};

export {
  deleteObject,
  displayHeaderControls,
  fixTooltipIssueOnClick,
  initColors,
  injectSvgIcons,
  setHeaderSummary,
  setSvgColor,
  getFontSizeValue,
  toggleObjectLock,
  changeToUnLock,
  changeToLock,
  lockObject,
  unlockObject,
  deselectObjects,
};
